import { Component, OnInit, OnDestroy, Input, inject } from '@angular/core';
import { distinctUntilChanged, filter, skip, switchMap, tap, map } from 'rxjs/operators';
import { interval } from 'rxjs';
import { Subscription } from 'rxjs';
import { ApiService } from '../api.service';
import { GraphApiService } from '../graph-api.service';

import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { NETWORK_STATUS_QUERY } from './network-status.model';
import { NetworkStatusUpdateService } from './network-status-update.service';

@Component({
    selector: 'nuso-network-status',
    template: '',
    standalone: false
})
export class NetworkStatusComponent implements OnInit, OnDestroy {
  private api = inject(ApiService);
  private graphApi = inject(GraphApiService);
  private networkStatusService = inject(NetworkStatusUpdateService);
  private snackBar = inject(MatSnackBar);
  private translateService = inject(TranslateService);


  @Input() pingInterval = 10000;

  pingSub: Subscription;
  notifySub: Subscription;
  notified = false;

  ngOnInit() {
    this.pingSub = interval(this.pingInterval)
      .pipe(
        switchMap(() => this.api.ping()),
        distinctUntilChanged()
      )
      .subscribe((isConnected: boolean) =>{
        this.networkStatusService.updateConnected(isConnected);
      });

    this.notifySub = this.graphApi.watchQuery<{ isConnected: boolean }>({ query: NETWORK_STATUS_QUERY })
      .pipe(
        // tap(networkStatus => console.log('NETWORK STATUS', networkStatus)),
        map(networkStatus => networkStatus.isConnected),
        // tap(isConnected => console.log({ isConnected })),
        skip(1),
        distinctUntilChanged(),
        tap(connected => {
          if (!connected) {
            this.notified = true;
            this.snackBar.open(this.translateService.instant('common.disconnected'), 'x')
          } else {
            // We don't want to clear the toast if first time seeing connected
            if (this.notified) {
              this.notified = false;
              this.snackBar.dismiss();
            }
          }
        })
      )
      .subscribe();
  }

  ngOnDestroy() {
    this.pingSub.unsubscribe();
    this.notifySub.unsubscribe();
  }

}
